import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyB27xdT7In0VhBDSvVLlo2dZcqlqSXs8bk",
  authDomain: "kinakata-6aba4.firebaseapp.com",
  databaseURL: "https://kinakata-6aba4-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "kinakata-6aba4",
  storageBucket: "kinakata-6aba4.firebasestorage.app",
  messagingSenderId: "170879492847",
  appId: "1:170879492847:web:aa89dbbc5032d39e06f11a",
  measurementId: "G-BR7P8G2SKQ"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);